// src/config/featureFlags.ts
// Feature flags configuration for the metronome application

export interface FeatureFlags {
  subdivisions: boolean;
  // Add more feature flags here as needed
  polyrhythm: boolean;
  customSongStructure: boolean;
  progressiveTempo: boolean;
  timer: boolean;
}

// Default feature flags - set to true to enable features
export const defaultFeatureFlags: FeatureFlags = {
  subdivisions: true,
  polyrhythm: false,
  customSongStructure: true,
  progressiveTempo: true,
  timer: true,
};

// Get feature flags from environment variables or localStorage
export const getFeatureFlags = (): FeatureFlags => {
  // Check for environment variables first (for build-time configuration)
  // const envFlags: Partial<FeatureFlags> = {};
  
  // Check localStorage for runtime configuration
  try {
    const storedFlags = localStorage.getItem('featureFlags');
    if (storedFlags) {
      const parsed = JSON.parse(storedFlags);
      return { ...defaultFeatureFlags, ...parsed };
    }
  } catch (error) {
    console.warn('Failed to parse feature flags from localStorage:', error);
  }
  
  return defaultFeatureFlags;
};

// Update feature flags in localStorage
export const updateFeatureFlag = <K extends keyof FeatureFlags>(
  flag: K,
  value: FeatureFlags[K]
): void => {
  try {
    const currentFlags = getFeatureFlags();
    const updatedFlags = { ...currentFlags, [flag]: value };
    localStorage.setItem('featureFlags', JSON.stringify(updatedFlags));
  } catch (error) {
    console.warn('Failed to update feature flag:', error);
  }
};

// Check if a specific feature is enabled
export const isFeatureEnabled = (flag: keyof FeatureFlags): boolean => {
  const flags = getFeatureFlags();
  return flags[flag];
};
